export default "assets/images/bg-slider-page-8311de0d.jpg";